export default __webpack_public_path__ + "locales/si/About.json?hash=edef95c0d5281699218292e247e0f9b9";